import { getUserTokens } from './getUserTokens'

export default function isLogged(): boolean {
  const tokens = getUserTokens()

  return !!tokens?.accessToken
}
